import React, { FC, ReactNode, useEffect } from 'react'
import { db } from 'firebase/index'
import { useSelector } from 'react-redux'
import { State } from 'index'
import dexieDb from 'lib/db'
import { getIsSignedIn } from 'reducks/auth/selectors'

type Props = {
  children: ReactNode
}

/**
 * PWAの自動アップデートのため
 * アプリ内のバージョン情報とDBのバージョン情報を比較する
 */
const VersionChecker: FC<Props> = (props) => {
  const { children } = props
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isSignedIn = useSelector((state: State) => getIsSignedIn(state))
  useEffect(() => {
    if (!isSignedIn) return
    db.collection('versions')
      .doc('admin')
      .get()
      .then(async (snapshot) => {
        const data = snapshot.data()
        if (!data || !('version' in data)) return
        // IndexedDBから該当バージョンを取得
        const appVersion = await dexieDb.appVersion.get(data.version)
        // 該当バージョンがなければ追加してリロード
        if (!appVersion) {
          await dexieDb.appVersion.put({ version: data.version })
          window.location.reload()
        }
      })
  }, [pathname, isSignedIn])
  return <>{children}</>
}

export default VersionChecker
